import React from "react"
import { Container, Typography } from '@material-ui/core'
import Grid from '@material-ui/core/Grid';

export default () => {
	return (
		<div style={{ paddingTop: "40px", paddingBottom: "80px", backgroundColor: "var(--aws-ligth)" }}>
			<Container>

				<Grid container direction="row">

					<Grid item xs={12} style={{ padding: "20px", textAlign: "center" }}>
						<Typography className="font-raleway" variant='h5' style={{ color: 'var(--azul)' }}>

							En Manantial creemos que la tecnología debe ser una extensión de nuestras vidas, algo que enriquezca nuestras experiencias personales y profesionales,por eso nuestro slogan es <label style={{ color: "var(--rojo)", fontWeight: "bold" }}>"We Make IT Personal"</label>.
							<p/>
							Imaginen un mundo donde su tecnología los entienda y que sean socios en su camino,eso es lo que buscamos cada día, nos sumergimos en la <label style={{ color: "var(--rojo)", fontWeight: "bold" }}>comprensión de sus necesidades únicas</label> y nos desafiamos a pensar de manera creativa.
							<p/>
							Nos tomamos el tiempo para <label style={{ color: "var(--rojo)", fontWeight: "bold" }}>construir relaciones, escuchar y conectar</label>. Ya sea que sean una nueva empresa que busca dejar su huella o una gran corporación que aspira a la excelencia, estamos aquí para acompañarlos en cada paso del camino. Unámonos para transformar la forma en que perciben la tecnología. <label style={{ color: "var(--rojo)", fontWeight: "bold" }}>Creemos algo extraordinario juntos!!!</label>


							{/* En un mundo donde las organizaciones y el mercado cambian constantemente, trabajamos y nos capacitamos 
							para ser una <label style={{ color: "var(--rojo)", fontWeight: "bold" }}>organización, ágil, líquida y 
							que fluye ( Manantial )</label>, buscamos soluciones creativas y de impacto, siendo conscientes 
							de que las personas son lo más importante. En Manantial buscamos el equilibrio entre el 
							trabajo y el bienestar de nuestra gente, buscando siempre crear un ambiente 
							de <label style={{ color: "var(--rojo)", fontWeight: "bold" }}>compañerismo, confianza, 
							humor</label> y donde podamos desarrollar 
							esa <label style={{ color: "var(--rojo)", fontWeight: "bold" }}>pasión por lo que hacemos</label>. */}
						</Typography>
					</Grid>

				</Grid>

			</Container>
		</div>
	)
}